module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', {
    staticClass: "sidebar__header",
    class: _vm.isWorkspace ? 'sidebar__header--student' : 'sidebar__header--teacher'
  }, [(_vm.isWorkspace) ? _c('h1', {
    staticClass: "sidebar__workspace-title",
    on: {
      "click": _vm.showCurrentPeriod
    }
  }, [_vm._v("Werkmap")]) : _vm._e(), (_vm.isWorkspace) ? _c('span', {
    staticClass: "sidebar__workspace-of"
  }, [_vm._v("van")]) : _vm._e(), _c('h3', {
    staticClass: "sidebar__user",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleUserMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "sidebar__user-button"
  }, [_c('span', {
    staticClass: "sidebar__user-icon"
  }), _c('span', {
    staticClass: "sidebar__user-name mini-hidden"
  }, [_vm._v(_vm._s(_vm.name(_vm.user)))])]), (!_vm.disableMenu) ? _c('user-menu', {
    attrs: {
      "show": _vm.isUserMenuVisible,
      "isDemo": _vm.isDemo,
      "isAdmin": _vm.isAdmin
    },
    on: {
      "hide": _vm.hideUserMenu
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-576920b5","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebar/SidebarHeader.vue
// module id = h+NG
// module chunks = 0 1